import { render } from "./pending-scorecards.vue?vue&type=template&id=71c3e24c&ts=true"
import script from "./pending-scorecards.vue?vue&type=script&lang=ts"
export * from "./pending-scorecards.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__